module.exports = __webpack_public_path__ + "static/img/certificate-cfa.3fcb6e2f.png";